module.exports = __webpack_public_path__ + "img/Hypoxia-GBM_10X_WTA.171a7f1d.png";